export default __webpack_public_path__ + "f78dbd9a77bdc4452b8ac0bbf695c359.png";